import React, {useState} from 'react'
import styled from 'styled-components'
import RegistrationWelcomePopup from '../../../../components/RegistrationWelcomePopup'
import RegistrationForm from '../../../containers/RegistrationForm.container'
import Background from '../../Background'
import Layout from '../../Layout'

const Content = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 18px;
`

function RegistrationPage() {
  const [popupOpen, setPopupOpen] = useState(true)
  return (
    <>
      <Layout noShadow>
        <Content>
          <Background />
          <RegistrationForm />
        </Content>
      </Layout>
      <RegistrationWelcomePopup
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
      />
    </>
  )
}

export default RegistrationPage
